export const enum TradingEnvironment {
  None = 'none',
  Live = 'live',
  Sim = 'sim'
}
